import MenuIcon from "@mui/icons-material/Menu";
import { Container, Divider } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import appcolors from "../../constants/Colors";
import CustomDrawer from "./Drawer";
import LoginPart from "./LoginPart";
import Navlinks from "./Navlinks";
import LandingFooter from "../landingFooter";
import CopyRight from "../landingFooter/CopyRight";

const drawerWidth = 240;

function AppHeader(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        component="nav"
        sx={{ boxShadow: "none", backgroundColor: appcolors.black }}
      >
        <Container maxWidth={"xl"}>
          <Toolbar
            sx={{ justifyContent: "space-between", padding: { xs: 0, md: 0 } }}
          >
            <Typography variant="h6" component="div">
              LOBA
            </Typography>
            <Navlinks />
            <LoginPart />
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          <CustomDrawer handleDrawerToggle={handleDrawerToggle} />
        </Drawer>
      </nav>
      <Box component="main" sx={{ width: "100%" }}>
        <Toolbar />
        {props.children}
        <Divider />
        <CopyRight />
      </Box>
    </Box>
  );
}

export default AppHeader;
